import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { loadStatus, loadStatuses } from '@sophocles/features/status/api';
import StatusSchema from '@sophocles/features/status/schema';
import { normalize } from 'normalizr';

const statusEntityAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'statuses',
  initialState: {
    statuses: statusEntityAdapter.getInitialState({}),
    view: {
      search: null,
      page: 0,
      order: 'asc',
      orderBy: 'id',
    },
  },
  reducers: {
    setPage(state, action) {
      state.view.page = action.payload;
    },
    setSearch(state, action) {
      state.view.search = action.payload;
    },
    setOrder(state, action) {
      state.view.order = action.payload;
    },
    setOrderBy(state, action) {
      state.view.orderBy = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(loadStatuses.fulfilled, (state, action) => {
      const { entities } = normalize(action.payload.results, [StatusSchema]);
      statusEntityAdapter.upsertMany(state.statuses, entities.statuses ?? {});
    });
    // Single-record load (detail panel) — carries measurements the list omits.
    builder.addCase(loadStatus.fulfilled, (state, action) => {
      statusEntityAdapter.upsertOne(state.statuses, action.payload);
    });
  },
});

export const selectStatusEntities = state => {
  return state.statuses.statuses;
};

export const { selectById: selectStatusById } = statusEntityAdapter.getSelectors(selectStatusEntities);

const { reducer } = slice;
export default reducer;
